import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from "../../../core/services/auth.service";
import {CurrentUserRoleAndLogin} from "../../../core/types/auth.types";

@Component({
  standalone: true,
  template: ''
})
export class BasePageComponent implements OnInit {
  private authService: AuthService = inject(AuthService);

  protected loginAndRoles: CurrentUserRoleAndLogin | null = null;

  public ngOnInit(): void {
    this.loginAndRoles = this.authService.getRolesAndLogin();
  }
}
